
jQuery(function($) {
    var header = $('#wrapper-navbar');
    var sticky = header.offset().top; 
    var content = $('#page');
    $(window).scroll(function() {
        if ($(window).scrollTop() > sticky) {
            header.addClass('sticky-header');
            $('#page').css('marginTop', header.outerHeight() + 'px');
        } else {
            header.removeClass('sticky-header');
            $('#page').css('marginTop', '0px');
        }
    });


if ($(window).scrollTop() > sticky) {
    header.addClass('sticky-header');
    content.css('marginTop', header.outerHeight() + 'px');
} else {
    header.removeClass('sticky-header');
    content.css('marginTop', '0px');
}

});



console.log('%c ', 'font-size: 0px; padding: 50px 50px; background: url("data:image/svg+xml,<%3Fxml version=\'1.0\' encoding=\'iso-8859-1\'%3F><!DOCTYPE svg PUBLIC \'-//W3C//DTD SVG 1.1//EN\' \'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\'><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --><svg height=\'800px\' width=\'800px\' version=\'1.1\' id=\'_x34_\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' viewBox=\'0 0 512 512\' xml:space=\'preserve\'><g><g><path style=\'fill:%23F5BF41;\' d=\'M511.993,256c0,141.377-114.608,256-255.993,256C114.613,512,0,397.377,0,256C0,114.609,114.613,0,256,0C397.384,0,511.993,114.609,511.993,256z\'/><g><g><path style=\'fill:%23E9AE3B;\' d=\'M451.823,319.517c-20.442,62.928-70.588,112.753-133.704,132.757c-6.949,2.207-10.797,9.63-8.591,16.572c2.2,6.943,9.623,10.79,16.566,8.583c71.297-22.633,127.699-78.677,150.827-149.76c2.257-6.928-1.541-14.373-8.469-16.63C461.523,308.791,454.079,312.588,451.823,319.517L451.823,319.517z\'/></g></g><g><path style=\'fill:%23F9D791;\' d=\'M256,0C114.613,0,0,114.609,0,256c0,82.805,39.349,156.38,100.329,203.174l358.844-358.844C412.38,39.349,338.804,0,256,0z\'/><g><path style=\'fill:%23FFFFFF;\' d=\'M199.047,30.816C117.969,51.35,53.872,114.451,31.897,194.949c-1.92,7.029,2.225,14.294,9.257,16.206c7.029,1.921,14.287-2.228,16.207-9.257C76.767,130.644,133.76,74.535,205.516,56.402c7.072-1.792,11.349-8.971,9.558-16.028C213.291,33.302,206.111,29.024,199.047,30.816z\'/></g></g></g><polygon style=\'fill:%23E94C1A;\' points=\'256,177.688 278.34,233.517 338.331,237.514 292.139,276.012 306.885,334.297 256,302.271 205.115,334.297 219.854,276.012 173.661,237.514 233.66,233.517 \'/></g></svg>") no-repeat; background-size: contain;');

